import { HttpRequestData, httpUtil } from '@esg/framework';
import { ObjectInfo, getEnv } from '@esg/shared';
import { GetUserRoleResponse } from '../roles';
import { UserTypeEnums } from './enums';

interface GetUserProfileRequest extends HttpRequestData {
}

export interface UserOrganizations {
    readonly organizationId: string;
    readonly organization: ObjectInfo;
}
interface GetUserProfileResponse {
    readonly id: string;
    readonly username: string;
    readonly email: string;
    readonly userRoles?: GetUserRoleResponse[];
    readonly userOrganizations: UserOrganizations[];
    userType: UserTypeEnums;
    employeeId?: string;
}

export const getUserProfile = httpUtil.createHttpRequestMeta<
    GetUserProfileRequest,
    GetUserProfileResponse
>({
    baseUrl: () => getEnv().IDENTITY_SERVER,
    path: '/api/v1/users/profile',
    method: 'GET',
    authentication: 'bearer'
});
